import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify';
import { AddSessionApi, CalendarOfSittingsAdd, constituencyMappedList, GetConstituency, GetConstituencyListForSearchFilter, GetKlaListForSearchFilter, GetMemberList, GetMemberMappingList, GetReservation, GetRole, GetSalutation, mapConstituency, MemberMappinAdd, SittingsListBasedOnSession, SubmitSittingsEdit } from '../../Services/allApi';
import DatePicker from 'react-datepicker';

// Custom option component
const CustomOption = (props) => {
    const { innerRef, innerProps, data } = props;
    const parts = data.label.split(" ");
    const constituency = parts[0];
    const reservedFor = parts[1];
    const reservedForMalayalam = parts[2]
  
    return (
      <div ref={innerRef} {...innerProps} className="custom-option">
        <div className="flex flex-row gap-2 w-full border border-blue-gray-300 bg-gray-100 mb-2 hover:bg-gray-300 cursor-pointer ">
          <div className="w-4/12 flex-1 flex p-1 border-r border-gray-300">{constituency}</div>
          <div className=" p-1 border-r border-gray-300 w-6 ">{reservedFor}</div>
          <div className=" p-1 items-start justify-start flex flex-col w-7/12  ">{reservedForMalayalam}</div>
        </div>
      </div>
    );
  };
  
  // Custom styles for the select component
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    menu: (provided) => ({
      ...provided,
      width: '1000px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: '0.5rem',
  }),
  };

function ConstituencyMapping({ handleCloseModalSS, detailsTable }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [videoDetailsArray, setVideoDetailsArray] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [klaList, setKlaList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [constituencyList, setconstituencyList] = useState([]);
  const [reservationList, setreservationList] = useState([]);
  const [saluationtList, setSaluationtList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [selectedOptionconstituency, setSelectedOptionconstituency] = useState(null);
  const [selectedOptionReservation, setSelectedOptionReservation] = useState(null);
  const [errMsg,setErrMsg]=useState()
  const [inputType, setinputType] = useState('text');
  const [VideoInitialDetails, setVideoInitialDetails] = useState({
    startDate: null,
    endDate: null,
    kla: null,
    video_session: null,
  });

  const [SessionIdAfterConnected, setSessionIdAfterConnected] = useState('')

  // sittings logic starts
  const [currentEntry, setCurrentEntry] = useState({
    constituency: '',
    description: '',
    malayalam_description: '',
    id: ''
  });

  const [entryList, setEntryList] = useState([]);

  const handleInputChangeSittings = (field, value) => {
    setCurrentEntry({
      ...currentEntry,
      [field]: value
    });
  };

  const handleAddEntry = () => {
    if (currentEntry.constituency && currentEntry.reservation) {
      setEntryList([currentEntry,...entryList]);
      setCurrentEntry({
        constituency: '',
        reservation: '',
        mal_reservation: ''
      });
    } else {
      toast.warning("Fill the form completely to add");
    }
  };

  const handleInputChangeListSittings = (index, field, value) => {
    const newEntryList = [...entryList];
    newEntryList[index][field] = value;
    setEntryList(newEntryList);
  };

  const handleRemoveEntry = (index) => {
    const newEntryList = entryList.filter((_, i) => i !== index);
    setEntryList(newEntryList);
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Content-Type": "application/json",
      "Authorization": `${token}`
    };

    const modifiedSittingsList = entryList?.map(item => ({
      constituency: item.constituency?.value,
      reservation: item?.reservation?.value,
      // mal_reservation: item?.mal_reservation,
    }));

    const klaId = detailsTable?.kla_id;

    const res = await mapConstituency(modifiedSittingsList, reqHeader, klaId);
    console.log(res);
    if(res?.status==200){
      handleCloseModalSS();
      // toast.success('Constituency mapped successfully')
      alert('Constituency mapped successfully')
    }
    else{
      alert(res?.response?.data?.message??'There was a problem !!')
    }
  };
  // sittings logic ends

  useEffect(() => {
    SittingsList();
  }, []);

  const SittingsList = async () => {
    const klaId = detailsTable?.kla_id;
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Content-Type": "application/json",
      "Authorization": `${token}`
    };

    const res = await constituencyMappedList({ kla_id: klaId }, reqHeader);
    // setErrMsg(res?.response?.data?.message)
    console.log(res);
    setEntryList(res?.data?.data??[]);
    setErrMsg(res?.response?.data?.message)
  }

  // Fetch Constituency List
  const ConstituencyListCallApi = async () => {
    try {
      
      const resultConstituency = await GetConstituencyListForSearchFilter();
      setconstituencyList(resultConstituency?.data?.data || []);
    } catch (error) {
      console.error("Error fetching Constituency list for filter:", error);
    }
  };

  useEffect(() => {
    ConstituencyListCallApi();
  }, []);

  const constituencyoptions = constituencyList.map((item) => ({
    value: item.constituency_id,
    label: `${item?.constituency_name} ${item?.constituency_no} ${item?.constituency_description}`
  }));

  const handlechangeconstituency = (option) => setSelectedOptionconstituency(option);

   // Fetch reservation List
   const ReservationList = async () => {
    try {
      const resul = await GetReservation();
      setreservationList(resul?.data?.data || []);
    } catch (error) {
      console.error("Error fetching Constituency list for filter:", error);
    }
  };

  useEffect(() => {
    ReservationList();
  }, []);

  const reservOptions = reservationList.map((item) => ({
    value: item?.id,
    label: item?.reserved_for
  }));

  const handleChangeReserv = (option) => setSelectedOptionReservation(option);

  return (
    <>
      <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
        <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>

          <div className='flex justify-end items-start w-full pb-1'><div onClick={handleCloseModalSS} className='flex justify-center items-center h-8 w-14 rounded border border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

          <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
            <div className='flex flex-col w-full gap-5'>
              <div className='bg-success px-4 py-2 rounded border'>
                <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Constituency Mapping</h3>

                <div className='flex flex-row justify-center flex-wrap mb-5 gap-5'>
                <div className='flex justify-start w-1/12' style={{visibility:'hidden'}}><h3 className='text-blue-500 text-sm text-left'>No 1</h3></div>
                  <div className='w-3/12 flex flex-col '>
                    <label htmlFor="sdate">Constituency</label>
                    <Select
                      placeholder='Constituency'
                      options={constituencyoptions}
                      value={currentEntry?.constituency}
                      onChange={(e) => handleInputChangeSittings('constituency', e)}
                      styles={customStyles}
                      components={{ Option: CustomOption }}
                    />
                  </div>

                  <div className='flex flex-col w-3/12'>
                    <label>Reserved for</label>
                    <Select
                      // type="text"
                      options={reservOptions}
                      value={currentEntry?.reservation}
                      onChange={(e) => handleInputChangeSittings('reservation',e)}
                      className='dateinput w-full h-10 rounded-lg'
                      style={{ border: '1px solid #384D6C' }}
                      styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderRadius: '0.5rem',
                        }),
                    }}
                    />
                  </div>
                  {/* <div className='flex flex-col w-3/12'>
                    <label>Reserved for (Malayalam)</label>
                    <input
                      type="text"
                      value={currentEntry.mal_reservation}
                      onChange={(e) => handleInputChangeSittings('mal_reservation', e.target.value)}
                      className='dateinput w-full h-10 rounded-lg'
                      style={{ border: '1px solid #384D6C' }}
                    />
                  </div> */}

                  <div className='w-2/12 flex flex-col ms-5'>
                    <label style={{ visibility: 'hidden' }}>Add</label>
                    <button className='w-full py-2 rounded-lg bg-green-500 text-white mb-3' onClick={handleAddEntry}>
                      Add
                    </button>
                  </div>
                  {(!entryList?.length>0)?
          <div className='flex flex-row justify-center items-center w-full h-full '><h3 className='text-red-500'>{errMsg?errMsg:'No mapping records found'}</h3></div>
          :
          <>
          <div className='w-full flex flex-col gap-2 mt-4'>
            {entryList?.map((entry, index) => (
              <div key={index} className='bg-gray-200 px-4 rounded border'>

                <div className='flex flex-row justify-center flex-wrap mb-1 gap-5'>
                <div className='flex justify-start w-1/12'><h3 className='text-blue-500 text-sm text-left'>No {index + 1}</h3></div>

                  <div className='w-3/12 flex flex-col '>
                    <label>Constituency</label>
                    <Select
                      options={constituencyoptions}
                      value={entry.constituency}
                      onChange={option => handleInputChangeListSittings(index, 'constituency', option)}
                      styles={customStyles}
                      components={{ Option: CustomOption }}
                    />
                  </div>

                  <div className='flex flex-col w-3/12'>
                    <label>Reserved for</label>
                    <Select
                     options={reservOptions}
                     value={entry?.reservation}
                    //  onChange={(e) => handleInputChangeSittings('reservation',e)}
                    //  className='dateinput w-full h-10 rounded-lg'
                    //  style={{ border: '1px solid #384D6C' }}
                    //   type="text"
                    //   value={entry.reservation}
                      onChange={(e) => handleInputChangeListSittings(index, 'reservation', e)}
                      className='dateinput w-full h-10 rounded-lg'
                      style={{ border: '1px solid #384D6C' }}
                      styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderRadius: '0.5rem',
                        }),
                    }}
                    />
                  </div>

                  {/* <div className='flex flex-col w-3/12'>
                    <label>Reserved for (Malayalam)</label>
                    <input
                      type="text"
                      value={entry.mal_reservation}
                      onChange={(e) => handleInputChangeListSittings(index, 'mal_reservation', e.target.value)}
                      className='dateinput w-full h-10 rounded-lg'
                      style={{ border: '1px solid #384D6C' }}
                    />
                  </div> */}

                  <div className='w-2/12 flex flex-col ms-5'>
                    <label style={{ visibility: 'hidden' }}>Remove</label>
                    <button className='w-full py-2 rounded-lg bg-red-500 text-white mb-3' onClick={() => handleRemoveEntry(index)}>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

         
            
          </>
           }
          
        </div>
      </div>
                  <div className='flex flex-row justify-center gap-5 w-full '>
              <div className='w-2/12 mb-5'>
                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                  Submit
                </button>
              </div>

              <div className='w-2/12'>
                <button className='w-full py-2 mt-20 rounded-full text-red-500 bg-success border' onClick={handleCloseModalSS}>
                  Cancel
                </button>
              </div>
            </div>
                </div>
              </div>
            </div>
          </div>

          

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default ConstituencyMapping;
